import React, { useState } from 'react';
import MatchListSelector from '../../match-list-selector';
import { MatchListItemLayout } from '../../utils/match-list.constants';
import { FilteredMarketGroupsOverview, MatchListCommon } from '../../utils/match-list-models';
import LiveMatchList from './live-match-list';
import { PlatformTypes } from '@om-fe/utils';

export interface LiveMatchListPublicProps extends MatchListCommon {
    readonly disciplineId: string;
    readonly locationId?: string;
    readonly isDefault?: boolean;
    readonly isLoadingData?: boolean;
    readonly eventCategoryId?: string;
    readonly itemLayout?: MatchListItemLayout;
    readonly showMatchListHeader: boolean;
    readonly showMarketInMatchListGroupHeader: boolean;
    readonly marketGroupsOverviewNumber?: number;
    readonly hasMarketSelector: boolean;
    readonly deviceType?: PlatformTypes;
    readonly showMarketSelectorHeader?: boolean;
    readonly isAuthenForTopic?: boolean;
    readonly groupOverviewData?: string;
    readonly filteredMarketGroupsOverview?: Record<string, FilteredMarketGroupsOverview>;
    readonly filteredMarketGroupsOverviewList?: string[];
}

type LiveMatchListSelectorProps = LiveMatchListPublicProps;

function LiveMatchListSelectorGroup(
    {
        instanceId,
        disciplineId,
        itemLayout,
        liveStatus,
        locationId,
        eventCategoryId,
        limitNumberOfEvents,
        mainMarketsLimit,
        marketsHeaderOptions,
        hasMarketSelector,
        showMatchListHeader,
        showMarketInMatchListGroupHeader,
        deviceType,
        activeMatchId,
        showMarketSelectorHeader,
        isAuthenForTopic,
        groupOverviewData,
        filteredMarketGroupsOverview,
        filteredMarketGroupsOverviewList,
    }: LiveMatchListSelectorProps,
) {
    const [groupOverview, setGroupOverview] = useState<string | undefined>(groupOverviewData);

    const selectGroupsOverview = (item: string) => {
        const listSelected = mainMarketsLimit === 1
            ? item
            : filteredMarketGroupsOverviewList?.slice(0, mainMarketsLimit - 1)
                .concat(item)
                .join(',');
        setGroupOverview(listSelected);
    };

    if (showMarketSelectorHeader && filteredMarketGroupsOverviewList?.length) {
        return (
            <LiveMatchList
                itemLayout={itemLayout}
                disciplineId={disciplineId}
                instanceId={instanceId}
                limitNumberOfEvents={limitNumberOfEvents}
                liveStatus={liveStatus}
                mainMarketsLimit={mainMarketsLimit}
                marketsHeaderOptions={marketsHeaderOptions}
                eventCategoryId={eventCategoryId}
                locationId={locationId}
                groupOverview={groupOverview}
                hasMarketSelector={hasMarketSelector}
                showMatchListHeader={showMatchListHeader}
                showMarketInMatchListGroupHeader={showMarketInMatchListGroupHeader}
                activeMatchId={activeMatchId}
                selectGroupsOverview={selectGroupsOverview}
                filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                isHasDrawer={true}
                deviceType={deviceType}
                preventRedirect={false}
                isAuthenForTopic={isAuthenForTopic}
            />
        );
    }

    return (
        <>
            {!!filteredMarketGroupsOverviewList?.length && (
                    <MatchListSelector
                        selectGroupsOverview={selectGroupsOverview}
                        filteredMarketGroupsOverview={filteredMarketGroupsOverview}
                        filteredMarketGroupsOverviewList={filteredMarketGroupsOverviewList}
                        marketSelected={groupOverview}
                        mainMarketsLimit={mainMarketsLimit}
                        isHasDrawer={true}
                        deviceType={deviceType}
                    />
                )
            }
            <LiveMatchList
                itemLayout={itemLayout}
                disciplineId={disciplineId}
                instanceId={instanceId}
                limitNumberOfEvents={limitNumberOfEvents}
                liveStatus={liveStatus}
                mainMarketsLimit={mainMarketsLimit}
                marketsHeaderOptions={marketsHeaderOptions}
                eventCategoryId={eventCategoryId}
                locationId={locationId}
                groupOverview={groupOverview}
                hasMarketSelector={hasMarketSelector}
                showMatchListHeader={showMatchListHeader}
                showMarketInMatchListGroupHeader={showMarketInMatchListGroupHeader}
                activeMatchId={activeMatchId}
                preventRedirect={false}
                isAuthenForTopic={isAuthenForTopic}
            />
        </>
    );
}

export default LiveMatchListSelectorGroup;
